








import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game, RoleComingOut } from '@/class/game'
import { MASTER_ROLE } from '@/class/const'

@Component
export default class RoleComingOutMessage extends Vue {
  @Prop() game!: Game
  @Prop() roleComingOut!: RoleComingOut

  get messages () {
    const messages: string[] = []

    if (this.roleComingOut.roleId) {
      messages.push(`${this.playerName}さんが${this.roleName}と名乗り出た`)
    } else {
      messages.push(`${this.playerName}さんが素性を隠した`)
    }

    return messages
  }

  get playerName() {
    return this.getName(this.roleComingOut.player.id)
  }

  get roleName() {
    return MASTER_ROLE[this.roleComingOut.roleId].name
  }

  getName(playerId: string) {
    return `${this.game.getGamePlayer(playerId).name}`
  }
}
